export default Object.freeze({
    Read: 1,
    Edit: 2,
    Create: 3,
    Delete: 4,
    Submit: 5,
    TagEdit: 6,
    Approve: 7,
    Share: 8,
    EditLimited: 9,
    CanCopyAsOwn: 99,
})
